import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { CREATE_BREAKPOINT } from './constants';
export var actionSectionDesktopCSS = _defineProperty({}, "@media (max-width: ".concat(CREATE_BREAKPOINT - 1, "px)"), {
  display: 'none !important'
});
export var actionSectionMobileCSS = _defineProperty({}, "@media (min-width: ".concat(CREATE_BREAKPOINT, "px)"), {
  display: 'none !important'
});
export var skeletonCSS = function skeletonCSS(_ref) {
  var skeleton = _ref.mode.skeleton;
  return _objectSpread({
    //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
    opacity: 0.15
  }, skeleton);
};